import React, { useMemo, useState } from "react";
import SeriesFetcher from "./SeriesFetcher";
import SeriesList from "./SeriesList";
import styled from "styled-components";
import CourseList from "./CourseList";
import LessonList from "./LessonList";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";

const Wrap = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 4%;

    margin-top: 30px;
`;

const IntroText = styled.div`
    max-width: 700px;
`;

const Column = styled.div`
    flex-basis: 30%;
    flex-shrink: 0;


    @media screen and (max-width: 800px) {
        flex-basis: 100%;

        display: none;

        ${props => {
            if (props.$active) {
                return `
                    display: block;
                `;
            }
        }
    }
`;

const ColumnHeading = styled.div`
    border-bottom: #7f807f 1px solid;
    margin-bottom: 10px;
    padding-bottom: 10px;

    display: flex;
    gap: 10px;

    h2 {
        margin: 0;
        font-size: 26px;
    }
`;

const BackBtn = styled.button`
    background-color: transparent;
    border: 0;
    outline: 0;
    color: #fff;
    cursor: pointer;
    font-size: 20px;
    display: none;

    @media screen and (max-width: 800px) {
        display: block;
    }
`;

export const List = styled.ul`
    padding: 0;
    list-style: none;
    margin-left: -5px;
    position: relative;

    ${({ $line }) => {
        if ($line) {
            return `
                &::before {
                    content: '';
                    position: absolute;
                    z-index: -1;
                    top: 16px;
                    left: 28px;
                    width: 1px;
                    height: calc(100% - 33px);
                    background-color:rgb(91, 91, 91);
                }
            `;
        }
    }}  
`;

export const ListItem = styled.li`
    padding: 10px 10px;
    margin 5px 0;
    font-size: 18px;
    font-weight: 600;
    background-color: ${({ active }) => (active ? '#3a3b3d' : 'transparent')};
    border: 1px solid transparent;
    border-color: ${({ active }) => (active ? '#7f807f' : 'transparent')};
    color: #fff;
    cursor: pointer;
    transition: background-color 0.2s ease, color 0.2s ease;

    display: flex;
    justify-content: space-between;
    align-items: center;

    .name {
        flex-grow: 1;
        margin: 0 8px;
    }

    &:hover {
        background-color: #2f2f2f;
    }
`;

export const NothingSelected = styled.div`
    padding: 10px;
    font-size: 18px;
    text-align: center;
    color: #999;
`;

const Series = () => {
    const [activeSeries, _setActiveSeries] = useState(null);
    const [activeCourse, setActiveCourse] = useState(null);
        
    const setActiveSeries = (index) => {
        _setActiveSeries(index);
        setActiveCourse(null);
    };

    const activeColumn = useMemo(() => {
        if (activeSeries === null) return 0;
        if (activeCourse === null) return 1;
        return 2;
    }, [activeSeries, activeCourse]);

    return (
        <div>
            <IntroText>
                <p>A "series" is a group of courses that focus on the same subject. These are the same courses from the "courses" tab, but this view shows how they are grouped together. This helps you track your progress through a series of related courses.</p>
            </IntroText>
            <SeriesFetcher>
                <Wrap>
                    <Column $active={activeColumn === 0}>
                        <ColumnHeading>
                            <h2>Series Topic</h2>
                        </ColumnHeading>
                        <SeriesList 
                            activeSeries={activeSeries} 
                            setActiveSeries={setActiveSeries} 
                        />
                    </Column>
                    <Column $active={activeColumn === 1}>
                        <ColumnHeading>
                            <BackBtn onClick={() => {
                                setActiveSeries(null);
                                setActiveCourse(null);
                            }}>
                                <FontAwesomeIcon icon={faChevronLeft} />
                            </BackBtn>
                            <h2>Courses</h2>
                        </ColumnHeading>
                        <CourseList
                            activeSeries={activeSeries}
                            activeCourse={activeCourse}
                            setActiveCourse={setActiveCourse}
                        />
                    </Column>
                    <Column $active={activeColumn === 2}>
                        <ColumnHeading>
                            <BackBtn onClick={() => {
                                setActiveCourse(null);
                            }}>
                                <FontAwesomeIcon icon={faChevronLeft} />
                            </BackBtn>
                            <h2>Lessons</h2>
                        </ColumnHeading>
                        <LessonList
                            activeSeries={activeSeries}
                            activeCourse={activeCourse}
                        />
                    </Column>
                </Wrap>
            </SeriesFetcher>
        </div>
    )
};

export default Series;
